// extracted by mini-css-extract-plugin
export default {"markDownContainer":"Jz4iknczdVsf3oUCLluA"};